import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TablePanelComponent } from './table-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [TablePanelComponent],
  exports: [TablePanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class TablePanelModule { }
